<template>
  <el-breadcrumb class="breadcrumb" separator="/">
    <el-breadcrumb-item v-for="item in levelList" :key="item.path">
      <span v-if="item.redirect === 'noRedirect' || index === levelList.length - 1" class="no-redirect">{{ item.meta.title }}</span>
      <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data() { return { levelList: [] } },
  watch: { $route() { this.getBreadcrumb() } },
  created() { this.getBreadcrumb() },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      this.levelList = matched
    },
    handleLink(item) { this.$router.push(item.redirect || item.path) }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb { display: inline-flex; font-size: 14px; }
.no-redirect { color: #97a8be; cursor: text; }
</style>
